/**
 * @generated SignedSource<<6c53767999c67eefca162af16dfdadf8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MarketingEmailDetailsViewTemplatesQuery$variables = {
  searchTerm?: string | null | undefined;
};
export type MarketingEmailDetailsViewTemplatesQuery$data = {
  readonly availableEmailTemplates: ReadonlyArray<{
    readonly emailTemplateIdentifier: string;
    readonly id: string;
    readonly name: string;
  }>;
};
export type MarketingEmailDetailsViewTemplatesQuery = {
  response: MarketingEmailDetailsViewTemplatesQuery$data;
  variables: MarketingEmailDetailsViewTemplatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchTerm"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "searchTerm",
        "variableName": "searchTerm"
      }
    ],
    "concreteType": "EmailTemplate",
    "kind": "LinkedField",
    "name": "availableEmailTemplates",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emailTemplateIdentifier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MarketingEmailDetailsViewTemplatesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MarketingEmailDetailsViewTemplatesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d787bbe726c0fe34ac10e2eaaf8c89f1",
    "id": null,
    "metadata": {},
    "name": "MarketingEmailDetailsViewTemplatesQuery",
    "operationKind": "query",
    "text": "query MarketingEmailDetailsViewTemplatesQuery(\n  $searchTerm: String\n) {\n  availableEmailTemplates(searchTerm: $searchTerm) {\n    id\n    emailTemplateIdentifier\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "9d500b90ec084719fa86bb48d16bb143";

export default node;
